"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListType = void 0;
var ListType;
(function (ListType) {
    ListType["WISHLIST"] = "wishlist";
    ListType["JOURNEY_EVALUATE"] = "journey_evaluate";
    ListType["JOURNEY_APPLY"] = "journey_apply";
})(ListType = exports.ListType || (exports.ListType = {}));
